// extracted by mini-css-extract-plugin
export var list = "related-list-module--list--B5S3L";
export var wrapper = "related-list-module--wrapper--J8wq-";